export default __webpack_public_path__ + "static/za-7ad48bd5eb85ba80dbed5cd7f86f033b.svg";